<!-- Toggle switch (iOS-style checkbox). -->
<script lang="ts">
  import type { Snippet } from "svelte";
  let { checked, onchange, id, small = false, title, children }: { checked: boolean; onchange: (v: boolean) => void; id?: string; small?: boolean; title?: string; children?: Snippet } = $props();
</script>

<label class="switch" class:small {title}><input type="checkbox" {id} {checked} onchange={(e) => onchange(e.currentTarget.checked)} /><span></span>{@render children?.()}</label>
